<template>
  <div>
    <vx-card class="mt-base mb-5">
      <heading size="h2" style-size="h4" class="mb-5">{{ activityTitle }}</heading>
      <p class="mb-5">
        This is an example of “monitoring people” and “looking for changes over time” (some of the
        tasks for nursing).
      </p>
      <p class="mb-5">
        <span class="text-bold text-underline_italic">Please note:</span> this is done more
        regularly in hospital, but it has been set at 8 hours here so that you can complete the task
        around school and letting your volunteers sleep.
      </p>

      <ul class="default-list">
        <li>Heart rate is a measurement of how many times your heart beats in one minute.</li>
        <li>
          Resting heart rate is how many heartbeats you have per minute when you aren’t exercising
          or otherwise under stress.
        </li>
        <li>
          Heart rate norms are based primarily on age rather than gender, although men tend to have
          slightly lower heart rates than women.
        </li>
        <li>
          The ideal resting heart rate for adults is 60 to 100 bpm. Very fit individuals such as
          athletes may have resting heart rates below 60 bpm.
        </li>
      </ul>
      <p class="mb-5">
        Remember, if possible take your volunteer's pulse when they have been resting.
        Exercise/activity will prevent you getting the “resting heart rate” - the following can also
        affect your heart rate:
      </p>

      <ul class="default-list">
        <li>temperature</li>
        <li>body position, such as lying, sitting, or standing</li>
        <li>emotional state</li>
        <li>caffeine intake</li>
        <li>certain medications</li>
        <li>underlying heart or thyroid conditions</li>
      </ul>

      <p class="mb-5">
        Don’t worry too much about all these, you can just make a note on your Observation Sheet in
        the BPA column if you feel any of these were present at the time.
      </p>

      <heading size="h3" style-size="h5" class="text-underline mb-5">
        To check your volunteer's pulse:
      </heading>
      <p class="mb-5">(The video on the right also demonstrates what to do).</p>

      <div class="vx-row mt-10 flex-row-reverse">
        <div class="vx-col lg:w-1/2 md:w-1/2 w-full mb-base pl-10">
          <video-trigger
            :imageSrc="videoTriggerImg1"
            button_id="take_pulse_video"
            @click="
              showVideoPopup(
                'https://www.youtube.com/embed/vmVjnpTv_Nk?autoplay=1',
                'take_pulse_video',
              )
            "
          ></video-trigger>
        </div>
        <div class="vx-col lg:w-1/2 md:w-1/2 w-full mb-base">
          <ul class="default-list">
            <li>
              Place your pointer and middle fingers on the inside of your volunteer's wrist just
              below the thumb.
            </li>
            <li>
              Don’t use your thumb to check the pulse, as the artery in your thumb can make it
              harder to count accurately.
            </li>
            <li>Once you can feel the pulse, count how many beats you feel in 30 seconds.</li>
            <li>
              Multiply this number by 2 to get your heart rate. For instance, 40 beats in 30 seconds
              equals a heart rate of 80 beats per minute (bpm).
            </li>
          </ul>
          <p class="mb-5">
            If over time the resting bpm measurement is irregular, you will need to count for the
            full 60 seconds.
          </p>

          <heading size="h3" style-size="h5" class="text-underline mb-5">You will need:</heading>

          <ul class="default-list">
            <li>Two volunteers that will be close by every 8 hours for the 24-hour period.</li>
            <li>Stopwatch or non-digital watch</li>
            <li>
              To download the “Observation (Obs) Chart” and fill in every time you take someone’s
              pulse. Then upload it after the task is complete.
            </li>
          </ul>

          <label>Download Observation (Obs) Chart</label><br />
          <a
            class="btn btn-primary btn-size-medium includedIcon mt-5 no-underline"
            :href="'content/nurse/obs_chart.pdf' | blob_url"
            target="_blank"
          >
            <download-icon />Download Obs Chart
          </a>
          <vs-divider />

          <p>Upload Observation (Obs) Chart:</p>
          <br />
          <fileupload-button-immediate
            v-model="uploaded_files['uploaded_file_1']"
            :is-editable="isEditable"
            filetype="pdf"
            index="1"
          />

          <save-buttons :is-editable="isEditable" @save="save" />
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import { DownloadIcon } from 'vue-feather-icons';

export default {
  components: {
    DownloadIcon,
  },
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
      videoTriggerImg1: require('@/assets/images/experiences/nurse/check_pulse.png'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
